import React, {useState} from "react";
import MDEditor from '@uiw/react-md-editor';
import { renderers } from './MarkdownDisplay';

const MarkdownEditor = (props) => {
  const [value, setValue] = useState(props.description);

  return (
    <div className="full_width open_sans">
      <MDEditor
        value={value}
        onChange={setValue}
        height={550}
        textareaProps={{name: props.name || 'blog_post[description]'}}
        previewOptions={{ renderers: renderers }}
      />
    </div>
  );
}

export default MarkdownEditor;
